import React from "react";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import SmartButton from "../../components/SmartButton";
import "./styles.scss";
import { oneLink } from "../../shared/oneLink";
import AnchorButton from "../../components/AnchorButton";

const Logout = () => {
    return (
        <MainLayout isBurgerHidden={true}>
            <Headline>ログアウトしました</Headline>
            <section className="logout">
                <p className="logout-message">
                    ご利用ありがとうございました。
                    <br />
                    引き続きアプリをお楽しみください。
                </p>

                <div className="user-action">
                    <AnchorButton href={oneLink()}>アプリを開く</AnchorButton>
                    <SmartButton
                        mode="secondary"
                        isLoading={false}
                        onClick={() => location.reload()}
                    >
                        ログインする
                    </SmartButton>
                </div>
            </section>
        </MainLayout>
    );
};

export default Logout;
